import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-background" >
{/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Back Button */}
          <Link to="/">
            <Button variant="ghost" className="mb-8 gap-2">
              <ArrowRight size={20} />
              العودة للرئيسية
            </Button>
          </Link>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            الشروط والأحكام
          </h1>
          <p className="text-muted-foreground mb-8">آخر تحديث: {new Date().toLocaleDateString('ar-SA')}</p>

          {/* Content Sections */}
          <div className="bg-card rounded-2xl shadow-lg p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">مقدمة</h2>
              <p className="text-foreground leading-relaxed">
                مرحباً بك في العليمي لاستضافة المواقع. باستخدام خدماتنا، فإنك توافق على الالتزام 
                بهذه الشروط والأحكام. يرجى قراءتها بعناية قبل استخدام خدماتنا.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">الخدمات المقدمة</h2>
              <p className="text-foreground leading-relaxed mb-4">
                نقدم خدمات استضافة مواقع الويب مع مساحة تخزين وعرض نطاق ترددي محددة حسب الباقة المختارة. 
                يحق لنا تعديل أو إيقاف الخدمات في أي وقت مع إشعار مسبق.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">التسجيل والحساب</h2>
              <div className="space-y-4 text-foreground leading-relaxed">
                <p>عند التسجيل، يجب عليك:</p>
                <ul className="list-disc list-inside space-y-2 mr-6">
                  <li>تقديم معلومات دقيقة وكاملة</li>
                  <li>الحفاظ على سرية بيانات حسابك</li>
                  <li>إخطارنا فوراً بأي استخدام غير مصرح به</li>
                  <li>تحديث معلومات حسابك بشكل دوري</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">الاستخدام المقبول</h2>
              <div className="space-y-4 text-foreground leading-relaxed">
                <p>يجب عليك عدم:</p>
                <ul className="list-disc list-inside space-y-2 mr-6">
                  <li>استخدام الخدمة في أي نشاط غير قانوني</li>
                  <li>نشر محتوى مخالف أو مسيء</li>
                  <li>استخدام الخدمة للبريد العشوائي أو الاحتيال</li>
                  <li>محاولة اختراق الخوادم أو الشبكة</li>
                  <li>نشر برامج ضارة أو فيروسات</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">الدفع والفوترة</h2>
              <div className="space-y-4 text-foreground leading-relaxed">
                <ul className="list-disc list-inside space-y-2 mr-6">
                  <li>تستحق رسوم الاشتراك مقدماً في بداية كل فترة فوترة</li>
                  <li>يتم التجديد التلقائي ما لم يتم الإلغاء</li>
                  <li>لا يوجد استرداد بعد بدء الخدمة</li>
                  <li>قد يتم تعليق الحساب عند التأخر في الدفع</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">ضمان وقت التشغيل</h2>
              <p className="text-foreground leading-relaxed">
                نضمن وقت تشغيل 99.9% علماً بأن بعض فترات الصيانة المجدولة قد تحدث. 
                لا نتحمل المسؤولية عن الانقطاعات الخارجة عن سيطرتنا.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">النسخ الاحتياطية</h2>
              <p className="text-foreground leading-relaxed">
                نقوم بعمل نسخ احتياطية يومية لبياناتك، لكن نوصي بشدة بالاحتفاظ بنسخ احتياطية خاصة بك. 
                لسنا مسؤولين عن فقدان البيانات.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">إنهاء الخدمة</h2>
              <div className="space-y-4 text-foreground leading-relaxed">
                <p>يحق لنا إنهاء أو تعليق حسابك في حالة:</p>
                <ul className="list-disc list-inside space-y-2 mr-6">
                  <li>انتهاك هذه الشروط والأحكام</li>
                  <li>الاستخدام غير القانوني للخدمة</li>
                  <li>عدم دفع الرسوم المستحقة</li>
                  <li>لأي سبب آخر نراه مناسباً</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">حدود المسؤولية</h2>
              <p className="text-foreground leading-relaxed">
                لا نتحمل المسؤولية عن أي أضرار مباشرة أو غير مباشرة ناتجة عن استخدام أو عدم القدرة على استخدام خدماتنا. 
                أنت مسؤول كامل عن محتوى موقعك.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">التعديلات</h2>
              <p className="text-foreground leading-relaxed">
                يحق لنا تعديل هذه الشروط في أي وقت. سيتم إخطارك بأي تغييرات جوهرية عبر البريد الإلكتروني. 
                استمرار استخدامك للخدمة يعني قبولك للتعديلات.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">الاتصال بنا</h2>
              <p className="text-foreground leading-relaxed">
                لأي أسئلة بخصوص الشروط والأحكام، يرجى التواصل معنا:
              </p>
              <div className="mt-4 space-y-2">
                <p className="text-foreground">البريد الإلكتروني: info@alulaimihosting.com</p>
                <p className="text-foreground" dir="ltr">الهاتف: +966 50 123 4567</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
